import styled from 'styled-components'

import { ScreenBreakpoints } from '../../theme'

const StyledMain = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;

  .main {
    width: 100%;
    height: 100%;

    @media (max-width: ${ScreenBreakpoints.large}px) {
      margin: 0 24px;
    }

    @media (min-width: ${ScreenBreakpoints.large + 1}px) and (max-width: ${ScreenBreakpoints.extraLarge}px) {
      margin: 0 48px;
    }

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      margin: 0 80px;
    }
  }

  .fixedWidth {
    @media (max-width: ${ScreenBreakpoints.large}px) {
      max-width: 694px;
      margin: 0 32px;
    }

    @media (min-width: ${ScreenBreakpoints.large + 1}px) and (max-width: ${ScreenBreakpoints.extraLarge}px) {
      max-width: 784px;
      margin: 0 48px;
    }

    @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
      max-width: 1140px;
      margin: 0 80px;
    }
  }

  &.with-sider-right {
    width: 100%;
    display: flex;
    justify-content: start;

    .main {
      width: 100%;
      display: flex;
      box-sizing: border-box;
      margin: 0px;

      @media (max-width: ${ScreenBreakpoints.large}px) {
        padding: 0 16px;
      }

      @media (min-width: ${ScreenBreakpoints.large + 1}px) and (max-width: ${ScreenBreakpoints.extraLarge}px) {
        padding: 0 16px;
      }

      @media (min-width: ${ScreenBreakpoints.extraLarge}px) {
        padding: 0 16px;
      }
    }
  }
`

export { StyledMain }
